<template>
  <div class="wrapper w-screen overflow-x-hidden">
    <div class="nav">
      <a href="/" class="logo">
        <img src="../assets/logo-l.png" alt="Nvoko Logo" />
      </a>
      <div class="nav-menu">
        <div @click="logout" class="log-out">
          Log Out
        </div>
      </div>
    </div>
    <div class="hero">
      <div class="logo">
        <img src="../assets/logo-b.svg" alt="Nvoko Logo" />
      </div>
      <div class="right">
        <div class="title">
          Welcome to our waitlist!
        </div>
        <div class="description">
          You'll be notified via your email once you're selected to join the
          platform.
        </div>
        <div class="register">
          <a href="/" class="sign-up">
            <template>
              Go back home
            </template>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GET_USER from "@/api/queries/GET_USER.gql";

export default {
  name: "Waitlisted",
  mounted() {
    // Refetch current user on page load in case their waitlist status changed
    this.refetchUser();
  },
  methods: {
    async refetchUser() {
      const userId = this.$store.getters["account/getUserId"];
      if (!userId) return;

      try {
        const { data } = await this.$apollo.query({
          query: GET_USER,
          variables: { id: userId },
          fetchPolicy: "network-only"
        });

        if (data && data.users_by_pk) {
          // Update store with latest user fields
          this.$store.commit("account/updateUser", data.users_by_pk);

          const user = data.users_by_pk;
          // If user is no longer waitlisted, navigate according to their state
          if (!user.is_waitlisted) {
            if (user.status && user.status !== "verified") {
              this.$router.push({ name: "SignupVerification" });
            } else if (!user.onboarding_complete) {
              this.$router.push({ name: "Onboarding" });
            } else {
              this.$router.push({ name: "Catalog" });
            }
          }
        }
      } catch (error) {
        // Fail silently but log for debugging
        console.error("Error refetching user on Waitlisted page:", error);
      }
    },
    logout() {
      // Clear user session
      this.$store.commit("account/logout");
      this.$token = null;
      // Redirect to login
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100vh;
  position: relative;
  background: rgba(0, 0, 0, 0.8);

  .nav {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15%;
    margin-top: 70px;

    .logo {
      padding-top: 7px;
      padding-bottom: 7.02px;
      padding-left: 7px;
      padding-right: 7px;
      justify-content: flex-start;
      align-items: flex-start;
      display: flex;
    }

    .nav-menu {
      padding-left: 40px;
      margin-left: auto;
      justify-content: center;
      align-items: center;
      gap: 35px;
      display: flex;

      .log-out {
        color: white;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        word-wrap: break-word;
        cursor: pointer;
      }

      .log-in {
        color: white;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        word-wrap: break-word;
        cursor: pointer;
      }

      .sign-up {
        padding: 10px 20px;
        background: #ff035a;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }

  .hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    height: calc(100vh - 114px);
    padding: 0 15%;

    .logo {
      width: 35%;

      img {
        width: 100%;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      width: 55%;

      .title {
        color: white;
        font-size: 5rem;
        font-weight: 600;
        line-height: 80px;
      }

      .description {
        margin-top: 30px;
        color: white;
        font-size: 2rem;
        font-weight: 400;
      }

      .description-light {
        margin-top: 30px;
        color: #ffffff90;
        font-size: 1rem;
        font-weight: 400;
      }

      .register {
        margin-top: 30px;
        display: flex;
        width: 100%;

        .email-input {
          background: rgba(255, 255, 255, 0.11);
          border-radius: 32.5px;
          border: 1.5px rgba(255, 255, 255, 0.3) solid;
          color: white;
          font-size: 1.2rem;
          font-weight: 700;
          padding: 10px 32px 12px;
        }

        .sign-up {
          background: #ff035a;
          border-radius: 30px;
          border: 1.5px #a60039 solid;
          color: white;
          font-size: 1.2rem;
          font-weight: 700;
          padding: 10px 22px 12px;
          margin-left: 15px;
        }
      }
    }
  }

  .how-does-it-work {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    .section-title {
      color: white;
      font-size: 2.1rem;
      font-weight: 700;
      padding: 10px 32px 12px;
      box-shadow: 0px 0px 20px white;
      border-radius: 46px;
      border: 1.5px white solid;
      margin-bottom: 20px;
    }

    .steps {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 100px;

      .step {
        display: flex;
        justify-content: center;

        .step-text {
          width: 35%;

          .title {
            margin-top: 60px;
            color: $white;
            font-size: 42px;
            font-weight: 700;
          }

          .description {
            color: $white;
            font-size: 22px;
            font-weight: 400;
          }
        }

        .step-number {
          border-left: 1px $accent solid;
          margin: 0 60px;

          .number {
            margin-top: 70px;
            font-size: 28px;
            background-color: $accent;
            border-radius: 50%;
            color: $white;
            width: 60px;
            height: 60px;
            padding-bottom: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: -30px;
          }
        }

        &:first-child {
          .step-number {
            margin-top: 70px;

            .number {
              margin-top: 0;
            }
          }
        }

        &:last-child {
          .step-number {
            height: fit-content;
          }
        }

        .deal-info {
          width: 35%;
          display: flex;
          flex-direction: column;
          margin-bottom: 60px;

          .party {
            border-radius: 18px;
            background: $white;
            padding: 8px 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 15px;
            width: fit-content;
            height: fit-content;

            .initials {
              height: 32px;
              width: 32px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 2px solid $accent;
              border-radius: 50%;
              color: $accent;
              font-size: 14px;
              font-weight: 700;
              line-height: 10px;
            }

            .party-tag {
              background-color: #000;
              color: $white;
              padding: 0 4px;
              border-radius: 5px;
            }
          }

          .ipi {
            display: flex;
            gap: 8px;
            padding: 6px 10px;
            width: fit-content;
            border-radius: 12px;
            background: $white;
            margin-left: 75px;

            .linked {
              display: flex;
              align-items: center;
              padding: 0 10px 2px;
              border-radius: 10px;
              background: #63be0a;
              color: $white;
              font-size: 14px;
              font-weight: 700;

              .icon {
                margin-right: 6px;
              }
            }
          }

          .summary {
            display: flex;
            gap: 8px;
            border-radius: 18px;
            background: $white;
            padding: 10px 0;
            width: fit-content;
            margin-left: 125px;
            margin-top: 21px;

            .el {
              border-right: 1px solid #9e9e9e;
              padding: 0 15px;

              &:last-child {
                border-right: 0;
              }

              .number {
                color: $accent;
                font-size: 22px;
                font-weight: 700;
              }
            }
          }

          .contribution-host {
            display: flex;
            gap: 24px;
            margin-left: 25px;
            margin-top: 21px;

            .contribution-container {
              border-radius: 18px;
              background: $white;
              padding: 10px 20px;

              .contribution {
                color: $accent;
                font-size: 24px;
                font-weight: 700;
              }
            }
          }

          .collaborator {
            display: flex;

            .party {
              margin-top: 21px;
            }

            .add-collaborator {
              button {
                display: flex;
                align-items: center;
                gap: 10px;
                background: #ff035a;
                border-radius: 30px;
                border: 2px $white solid;
                color: $white;
                font-size: 18px;
                font-weight: 700;
                padding: 4px 32px 6px;
                margin-left: -12px;
              }
            }
          }
        }

        .contract-questions {
          width: 35%;
          display: flex;
          flex-direction: column;
          margin-bottom: 60px;

          .question {
            border-radius: 18px;
            background: $white;
            padding: 18px 25px 20px;
            width: fit-content;

            .title {
              font-size: 20px;
              font-weight: 600;
              margin-bottom: 10px;
            }

            .question-text {
              margin-bottom: 10px;
            }

            .options {
              display: flex;
              gap: 10px;

              .option {
                border-radius: 10px;
                background: #f0f0f0;
                padding: 13px 20px 15px;
                white-space: nowrap;

                &.selected {
                  background-color: $accent;
                  color: $white;
                }
              }
            }
          }

          .status {
            display: flex;
            align-items: center;
            gap: 10px;
            border-radius: 20px;
            padding: 10px 20px 13px;
            color: $white;
            font-size: 20px;
            font-weight: 600;
            width: fit-content;
            height: fit-content;
            white-space: nowrap;

            .icon {
              height: 20px;
              width: 20px;
              display: flex;
              align-items: center;
            }
          }

          .row-1 {
            display: flex;
            margin-left: 75px;

            .status {
              background-color: $accent;
              margin-top: 10px;
              margin-left: -50px;
            }
          }

          .row-2 {
            display: flex;
            margin-top: 65px;
            width: 100%;

            .question-1 {
              min-width: 60%;

              .option {
                width: calc(50% - 5px);
                text-align: center;
              }
            }

            .question-2 {
              height: fit-content;
              display: flex;
              gap: 10px;
              transform: translate(-205px, -40px);

              .status {
                background-color: #03a4ff;
                position: relative;
              }
            }
          }
        }

        .contract-final {
          width: 35%;
          margin-bottom: 60px;

          .top {
            display: flex;
            gap: 20px;
            width: fit-content;

            button {
              display: flex;
              align-items: center;
              gap: 5px;
              background: #03a4ff;
              border-radius: 30px;
              border: 2px $white solid;
              color: $white;
              font-size: 18px;
              font-weight: 700;
              padding: 4px 32px 6px;

              .icon {
                height: 30px;
                width: 30px;
                display: flex;
                align-items: center;
              }
            }

            .ip {
              display: flex;
              gap: 8px;
              padding: 6px 10px;
              width: fit-content;
              border-radius: 12px;
              background: $white;

              .recorded {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0 10px 2px;
                border-radius: 10px;
                background: #4b4b4b;
                color: $white;
                font-size: 14px;
                font-weight: 700;

                .icon {
                  margin-right: 6px;
                }
              }
            }
          }

          .agreement-container {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            width: calc(90% + 20px);

            .agreement {
              background-color: $white;
              border-radius: 20px;
              width: calc(100% - 20px);
              padding: 0 10px;
              overflow: hidden;

              .container {
                position: relative;
                top: 10px;
                display: flex;

                .text {
                  .title {
                    color: #000;
                    font-size: 25px;
                    font-weight: 700;
                  }
                }

                .scroll {
                  width: 50px;
                  margin: 10px 0 30px 20px;
                  border-radius: 9px;
                  background: #777777;

                  .thumb {
                    background: $accent;
                    border-radius: 9px;
                    height: 30px;
                    width: 100%;
                  }
                }
              }
            }

            .accept-sign {
              margin-top: -12px;
              margin-left: auto;
              z-index: 50;

              button {
                display: flex;
                align-items: center;
                gap: 10px;
                background: #ff035a;
                border-radius: 30px;
                border: 2px $white solid;
                color: $white;
                font-size: 18px;
                font-weight: 700;
                padding: 4px 24px 6px;
                margin-left: -12px;
              }
            }

            .signature-container {
              display: flex;
              gap: 10px;
              margin-top: -12px;
              margin-left: 40px;

              .icon {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
                border-radius: 20px;
                border: 3px solid $accent;
                background-color: $white;

                img {
                  /* height: 45px; */
                  width: 45px;
                }
              }

              .signature {
                padding: 0 40px;
                border-radius: 30px;
                font-size: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-bottom: 3px;
                background-color: $white;
                color: #000;
              }
            }
          }
        }
      }
    }
  }

  .join-community {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    .section-title {
      color: $white;
      font-size: 40px;
      font-weight: 700;
      margin-bottom: 20px;
    }

    .testimonials {
      width: 80%;
      display: flex;
      gap: 30px;
      margin-top: 70px;

      .testimonial {
        width: calc(33% - 20px);
        color: $white;
        border: 30px solid;
        border-image: url("../assets/testimonial-border.svg");
        border-image-slice: 40;
        border-radius: 10px;
        padding: 0 25px 25px;

        .quotes {
          margin-top: -70px;
        }

        .top {
          display: flex;
          gap: 15px;
          margin-top: 25px;

          .avatar {
            img {
              border-radius: 10px;
            }
          }

          .right {
            .name {
              font-size: 22px;
              font-weight: 600;
            }

            .user-title {
              font-size: 16px;
              font-weight: 400;
            }
          }
        }

        .description {
          margin-top: 10px;
          font-size: 18px;
          font-weight: 400;
        }
      }
    }

    .slider-control {
      display: flex;
      gap: 10px;
      margin-top: 20px;

      .point {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #fff;
      }
    }
  }

  .get-started {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 100px;

    .main,
    .unlimited {
      width: 45%;
      border-radius: 22px;
      border: 2px solid $accent;
      display: flex;
      align-items: center;
    }

    .main {
      flex-direction: column;
      justify-content: center;
      padding: 35px 60px 45px;

      .title {
        color: $white;
        font-size: 34px;
        font-weight: 700;
        margin-bottom: 20px;
      }

      .action {
        margin-top: 20px;
      }
    }

    .unlimited {
      margin-top: 20px;
      padding: 15px 30px;

      .action {
        margin-left: auto;
      }
    }

    .description {
      color: $white;
      font-size: 21px;
      font-weight: 400;
      text-align: center;
    }

    .accent {
      color: $accent;
    }

    .action {
      button {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #ff035a;
        border-radius: 30px;
        border: 3px solid #a60039;
        color: $white;
        font-size: 18px;
        font-weight: 700;
        padding: 4px 24px 6px;
        margin-left: -12px;
      }
    }
  }

  .footer {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .logo {
      img {
        height: 50px;
      }
    }

    .links {
      margin: 30px 0 20px;
      display: flex;
      gap: 30px;

      .link,
      .copyright {
        color: $white;
        font-size: 16px;
        font-weight: 400;
      }

      .link {
        font-weight: 800;
      }

      .socials {
        margin-left: 60px;
        display: flex;
        gap: 20px;

        .icon {
          height: 30px;
          width: 30px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.error {
  padding-left: 10px;
  color: #a60039;
  font-weight: 600;
}

button {
  cursor: pointer;
}

@media (max-width: 768px) {
  .wrapper {
    .nav {
      padding: 0 5%;
      margin-top: 35px;

      .logo {
        width: 30%;
      }

      .nav-menu {
        .log-in {
          text-align: center;
          cursor: pointer;
        }

        .sign-up {
          text-align: center;
          padding: 6px 12px;
          cursor: pointer;
        }
      }
    }

    .hero {
      flex-direction: column;
      height: auto;
      padding: 40px 5%;

      .logo {
        width: 100%;
        padding: 0 15%;
        text-align: center;

        img {
          max-width: 100px;
          display: inline;
        }
      }

      .right {
        width: 100%;
        margin-top: 20px;

        .title {
          font-size: 3rem;
          line-height: 50px;
        }

        .description {
          font-size: 1.5rem;
        }

        .register {
          flex-direction: column;
          padding: 0 5%;

          .sign-up {
            margin-top: 15px;
            margin-left: 0;
          }
        }
      }
    }

    .how-does-it-work {
      margin-top: 80px;

      .section-title {
        font-size: 1.8rem;
      }

      .steps {
        margin-top: 60px;

        .step {
          flex-direction: column;
          flex-direction: column-reverse;
          justify-content: center;
          align-items: center;
          width: 100vw;
          position: relative;
          padding: 0 0 10px 60px;

          .step-number {
            margin: 0 !important;
            position: absolute;
            top: 0;
            left: 40px;
            height: 100%;

            .number {
              width: 40px;
              height: 40px;
              font-size: 22px;
              margin-left: -20px;
              margin-top: 0;
            }
          }

          &:last-child {
            .step-number {
              height: 100%;
            }
          }

          .step-text {
            width: 100%;
            padding: 0 7%;

            .title {
              margin: 0;
              margin-bottom: 15px;
              font-size: 34px;
              line-height: 40px;
            }

            .description {
              font-size: 18px;
            }
          }

          .deal-info {
            transform: scale(0.55);
            width: fit-content;
            margin: -40px;
            margin-left: -20%;
          }

          .contract-questions {
            transform: scale(0.35);
            width: fit-content;
            margin: -20% 0;
            margin-left: -4%;
          }

          .contract-final {
            transform: scale(0.55);
            width: fit-content;
            margin: -50px -50px -100px -20%;
          }

          &:nth-child(2) {
            flex-direction: column;
          }
        }
      }

      .steps-end {
        width: 100%;

        .circle {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: $accent;
          margin-left: 32px;
        }
      }
    }

    .join-community {
      text-align: center;
      overflow-x: hidden;

      .testimonials {
        .testimonial {
          width: 100%;
        }
      }
    }

    .get-started {
      padding: 0 5%;

      .main,
      .unlimited {
        width: 100%;
        flex-direction: column;
        padding: 10px 20px;

        .action {
          margin-left: 0;
          margin-top: 20px;
        }
      }
    }

    .footer {
      .links {
        flex-direction: column-reverse;
        align-items: center;

        .socials {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
